export function SnowflakeCheck() {
  return (
    <path
      fill="currentColor"
      d="m17.75 21.16l-2.75-3L16.16 17l1.59 1.59L21.34 15l1.16 1.41zM12 18c0-1.54.59-2.94 1.54-4l-1.54.89l-2.5-1.45v-2.88L12 9.11l2.5 1.45v2.57a6 6 0 0 1 1.96-.92v-1.65l2-1.13l2.33.62l.52-1.93l-1.77-.47l.46-1.77l-1.93-.52l-.62 2.33l-2 1.13L13 7.38V5.12l1.71-1.71L13.29 2L12 3.29L10.71 2L9.29 3.41L11 5.12v2.26L8.5 8.82l-2-1.13l-.58-2.33L4 5.88l.47 1.77l-1.77.47l.52 1.93l2.33-.62l2 1.13v2.89l-2 1.13l-2.33-.62l-.52 1.93l1.77.47L4 18.12l1.93.52l.62-2.33l2-1.13L11 16.62v2.26l-1.71 1.71L10.71 22L12 20.71L13.29 22l.13-.13A5.94 5.94 0 0 1 12 18"
    ></path>
  )
}
